/*
* @描述: 订单列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/12 16:59
*/
<template>
    <PullContainer ref="pullContainerRef" :pullDownLabel="true" :pullDownLoading="false">
        <template #container>
            <div v-loading="loading" class="public_container">
                <div class="returnNavBar">
                    <ReturnNavBar :isAllFunctions="true" :isTitleNormal="true" title="返回"></ReturnNavBar>
                    <span class="handle_icon_wrap" @click="handleClickAddRepayment">
                        <i class="iconfont icon-a-tianjiamiaobian"></i>
                    </span>
                </div>
                <div class="top_search">
                    <van-search v-model="searchForm.keyword"
                                placeholder="请输入查询内容"
                                @clear="onSearch"
                                @search="onSearch">
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <ul v-infinite-scroll="scrollLoadList" class="payment_list">
                        <li v-for="(row, index) in paymentList" :key="index" class="payment_item">
                            <div class="payment_item_header">
                                <div class="flex_wrap">
                                    <div class="receivable_no_wrap" @click="handleClickPaymentDetail(row)"
                                         v-text="row.receivable_no"></div>
                                    <span :class="'payment_status_name_'+row.status" class="status_name"
                                          v-text="row.status_name"></span>
                                    <span v-if="row.status===3||row.status===5" class="handle_icon_wrap"
                                          @click="handleClickShowReason(row)">
                                        <i class="iconfont icon-jinggao"></i>
                                    </span>
                                </div>
                                <span v-if="row.status===1&&row.uid===userInfo.user.id"
                                      class="handle_icon_wrap"
                                      @click="handleClickPaymentRevoke(row)">
                                    <i class="iconfont icon-chexiao"></i>
                                </span>
                                <span v-else-if="row.status===3||row.status===4||row.status===5"
                                      class="handle_icon_wrap"
                                      @click="handleClickPaymentAgain(row)">
                                    <i class="iconfont icon-zaicitijiao"></i>
                                </span>
                            </div>
                            <div class="payment_item_content">
                                <div class="flex_wrap">
                                    <span class="field_label">回款公司：</span>
                                    <span class="field_value" v-text="row.payment_company_name"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">申请人：</span>
                                    <div class="custom_contact_field_wrap">
                                        <PersonnelCard v-if="row.uid_info" :userId="row.uid">
                                            <template slot="container">
                                                <img :src="row.uid_info.avatar || defaultImg" alt=""
                                                     class="avatar">
                                                <span class="name" v-text="row.uid_info.name"></span>
                                            </template>
                                        </PersonnelCard>
                                    </div>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">回款金额：</span>
                                    <span class="field_value" v-text="row.payment_amount"></span>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">回款日期：</span>
                                    <span class="field_value" v-text="row.payment_date"></span>
                                </div>
                            </div>
                        </li>
                        <li v-if="paymentList.length >= pagination.total" class="ta_c">--已经到底了--</li>
                    </ul>
                </div>
                <FooterTabbar :tabBarActive="tabBarActive" :tabBarList="tabBarList"></FooterTabbar>
                <RepaymentDialog v-if="repaymentDialogVisible"
                                 :dialogVisible.sync="repaymentDialogVisible"
                                 :receivable_no.sync="receivable_no"
                                 :source="'list'"
                                 @refresh="onSearch"/>
                <RepaymentDetail v-if="repaymentDetailDialogVisible"
                                 :dialogVisible.sync="repaymentDetailDialogVisible"
                                 :receivable_no.sync="receivable_no"/>
            </div>
        </template>
    </PullContainer>
</template>
<script>
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import RepaymentDialog from "./component/repayment_add"
import {pagination} from "@/mixins";
import {orderRepaymentList, orderRepaymentRecordCancel} from '@/api'
import {mapState} from "vuex";
import RepaymentDetail from "@/views/mobile/Order/component/repayment_detail.vue";

export default {
    name: "PaymentList",
    data() {
        return {
            loading: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "Order",
                    title: "首页",
                },
                {
                    icon: "icon-a-dingdan1",
                    activeIcon: "icon-a-dingdan26",
                    routerName: "OrderList",
                    title: "订单",
                },
                {
                    icon: "icon-tuikuan",
                    activeIcon: "icon-tuikuan1",
                    routerName: "PaymentList",
                    title: "回款",
                },
                {
                    icon: "icon-fapiao",
                    activeIcon: "icon-a-fapiao1",
                    routerName: "InvoiceList",
                    title: "开票",
                },
            ],
            tabBarActive: 2,
            searchForm: {
                keyword: '',
                status: '',
                payment_date: '',
                payment_method: '',
            },
            paymentList: [],
            defaultImg: require('@/assets/images/default.jpg'),
            repaymentDialogVisible: false,
            repaymentDetailDialogVisible: false,
            receivable_no: ''
        }
    },
    mixins: [pagination],
    components: {
        RepaymentDetail,
        PersonnelCard,
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        RepaymentDialog,
    },
    created() {
        this.getOrderPaymentList()
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    mounted() {

    },
    methods: {
        handleClickAddRepayment() {
            this.repaymentDialogVisible = true
        },

        onSearch() {
            this.pagination.pageNum = 1
            this.paymentList = []
            this.getOrderPaymentList()
        },

        handleClickAdvancedFilter() {

        },

        scrollLoadList() {
            if (this.paymentList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getOrderPaymentList()
            }
        },

        //获取回款汇总列表
        getOrderPaymentList() {
            this.loading = true
            orderRepaymentList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                status: this.searchForm.status,
                payment_date: this.searchForm.payment_date ? this.searchForm.payment_date : [],
                payment_method: this.searchForm.payment_method,
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    this.paymentList = this.paymentList.concat(data)
                    this.pagination.total = total
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false;
            })
        },

        //回款详情
        handleClickPaymentDetail(row) {
            this.repaymentDetailDialogVisible = true
            this.receivable_no = row.receivable_no
        },

        //撤销回款
        handleClickPaymentRevoke(row) {
            this.$dialog.confirm({
                title: '确定撤销当前回款记录？',
                message: '撤销后不可恢复，请谨慎操作！',
            }).then(() => {
                orderRepaymentRecordCancel({
                    receivable_no: row.receivable_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功！')
                        this.getOrderPaymentList()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        // 点击重新提交
        handleClickPaymentAgain(row) {
            this.receivable_no = row.receivable_no
            this.repaymentDialogVisible = true
        },

        //点击弹出原因
        handleClickShowReason(row) {
            const reason = row.status === 3 ? row.reject_reason : row.invalid_reason
            this.$dialog.alert({
                title: row.status === 3 ? '驳回原因' : '作废原因',
                message: reason,
                confirmButtonColor: '#2990ff'
            }).then(() => {
                return false
            }).catch(() => {
                return false
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.mobile_container {
    overflow-y: hidden;
    padding-top: 10px;

    .payment_list {
        width: 100%;
        height: 100%;
        overflow-y: auto;

        .payment_item {
            margin-bottom: 4px;
            background: #FFFFFF;
            padding: 10px 16px 2px;

            .payment_item_header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                border-bottom: 1px solid #E8E8E8;
                padding-bottom: 8px;

                .receivable_no_wrap {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 22px;
                    color: #2990FF;
                }

                .status_name {
                    color: #666666;
                    vertical-align: middle;
                    margin-left: 4px;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 4px;
                    }

                    &.payment_status_name_1::before {
                        background: #F0AA32;
                    }

                    &.payment_status_name_2::before {
                        background: #5AB333;
                    }

                    &.payment_status_name_3::before {
                        background: #E44144;
                    }

                    &.payment_status_name_4::before {
                        background: #BFBFBF;
                    }

                    &.payment_status_name_5::before {
                        background: #E44144;
                    }
                }
            }

            .payment_item_content {
                padding-top: 10px;

                .flex_wrap {
                    line-height: 22px;
                    margin-bottom: 8px;
                }

                .field_label {
                    color: #999999;
                }

                .field_value {
                    color: #333333;
                }
            }
        }
    }
}
</style>